import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class SameCodeItem extends Component {
  state = {
    chkValue: false,
  };
  componentDidMount = () => {
    const { sameCode, chkCode } = this.props.childProps;
    //console.log(chkCode)

    const pos = chkCode.find((item, index) => {
      return sameCode === item;
    });
    if (pos !== undefined) {
      this.setState({
        chkValue: true,
      });
    }
  };
  _checkChange = (e) => {
    ////console.log(e)
    const { chkValue } = this.state;
    const { sameCode, sameCodeAdd, sameCodeDel } = this.props.childProps;

    if (!chkValue) {
      sameCodeAdd(sameCode);
      //TagSearchList 함수 Props로 받아서 "202007|202001" 형식으로 만들어 보낼것.
    } else {
      sameCodeDel(sameCode);
      //해당 코드 삭제.
    }

    this.setState({
      chkValue: !chkValue,
    });
  };
  render() {
    const { chkValue } = this.state;
    const { sameCode, sameName, init } = this.props.childProps;
    return (
      <Fragment>
        <dd>
          <div className="chek_group">
            <input
              name="선택"
              id={`checkbox_${sameCode}`}
              type="checkbox"
              value=""
              checked={init ? false : chkValue}
              className="checkbox_img"
              onChange={this._checkChange}
            />
            <label htmlFor={`checkbox_${sameCode}`}>{sameName}</label>
          </div>
        </dd>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SameCodeItem));
